import ApiService from "helpers/ApiHelper";

/**
 * Machine-translation assist for the CMS editors.
 *
 * Note the singular `translation` — `/api/v1/translations` is a different,
 * unrelated endpoint (per-user profile translations).
 *
 * This never writes: it answers with suggested text that the editor drops into
 * a field and still has to save by hand. That is the whole safety story of the
 * assist button — a bad suggestion costs a keystroke, not a published page.
 */
export const assistTranslate = async (text, targetLang, sourceLang = "bg") => {
  const data = await ApiService.request("/api/v1/translation/assist", "post", {
    text,
    targetLang,
    sourceLang,
  });
  return data?.text ?? "";
};
